import script from "./MobileDispatchDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileDispatchDetail.vue?vue&type=script&setup=true&lang=js"

import "./MobileDispatchDetail.vue?vue&type=style&index=0&id=50fb6e45&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50fb6e45"]])

export default __exports__